import {
  formatOptLogSnapshotDisplayRowAsLine,
  type OptLogSnapshotDisplayRow,
} from '~/shared/utils/optLogActionSnapshot';

import OptLogSnapshotBlankMetricLine from './OptLogSnapshotBlankMetricLine';

export interface ActionSnapshotCellProps {
  rows: OptLogSnapshotDisplayRow[];
}

export default function ActionSnapshotCell({ rows }: ActionSnapshotCellProps) {
  if (rows.length === 0) {
    return null;
  }

  return (
    <div className="flex w-max min-w-0 flex-col gap-[3px] py-1">
      {rows.map((row) => {
        if (row.isPlaceholder) {
          return <OptLogSnapshotBlankMetricLine key={row.kind} />;
        }
        return (
          <span
            key={row.kind}
            className="block min-h-[20px] shrink-0 whitespace-nowrap text-[14px] font-medium leading-5 text-primary-900"
          >
            {formatOptLogSnapshotDisplayRowAsLine(row)}
          </span>
        );
      })}
    </div>
  );
}
